export enum DeliveryTypeEnum {
  SELF_DELIVERY = 'SELF_DELIVERY',
  DELIVERY = 'DELIVERY',
}
